module.exports = __webpack_public_path__ + "img/Friends.a398ec2c.png";